var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.sport === 'soccer')?_c('team-page-soccer'):_vm._e(),(_vm.sport === 'bsktbl')?_c('team-page-basketball'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }